import React, { useState } from 'react';
import './Testimonial.css';

const Testimonial = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Vedika",
      title: "Girls Who Walk London",
      quote: "Yes I would definitely use your services again as it was so easy and efficient and we managed to find the perfect venue!",
      image: "/Female.png" // You'll need to add this image
    },
    // {
    //   id: 2,
    //   name: "Sarah Johnson",
    //   title: "Event Director, Creative Collective",
    //   quote: "Occasia transformed how we approach venue selection. The platform's intuitive interface and diverse space options made finding the perfect venue effortless. Our events have never been more successful!",
    //   image: "/Female-1.png" // You'll need to add this image
    // },
    // {
    //   id: 3,
    //   name: "Michael Chen",
    //   title: "CEO, TechStart Events",
    //   quote: "The quality of venues on Occasia is outstanding. We've hosted multiple tech meetups and workshops, and each venue has exceeded our expectations. Highly recommended!",
    //   image: "/Male.png" // You'll need to add this image
    // }
  ];

  return (
    <div className="container-padding bg-primary-dark md:py-32 py-16">
      <div className="content-width mx-auto">
        <div className="testimonial-header">
          <h2 className="testimonial-title">DON'T TAKE OUR WORD FOR IT</h2>
          <h3 className="testimonial-subtitle">Hear it from our clients</h3>
        </div>
        
        <div className="testimonial-content">
          <div className="testimonial-profiles">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`profile-picture ${index === currentTestimonial ? 'active' : ''}`}
                onClick={() => setCurrentTestimonial(index)}
              >
                <img 
                  src={testimonial.image || `https://via.placeholder.com/80x80/587042/ffffff?text=${testimonial.name.charAt(0)}`}
                  alt={testimonial.name}
                  className="profile-image"
                />
              </div>
            ))}
          </div>
          
          {/*<div className="testimonial-navigation">*/}
          {/*  <button className="nav-arrow prev" onClick={prevTestimonial}>*/}
          {/*    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">*/}
          {/*      <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
          {/*    </svg>*/}
          {/*  </button>*/}
          {/*  <button className="nav-arrow next" onClick={nextTestimonial}>*/}
          {/*    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">*/}
          {/*      <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
          {/*    </svg>*/}
          {/*  </button>*/}
          {/*</div>*/}
        </div>
        
        <div className="testimonial-quote">
          <p className="quote-text">{testimonials[currentTestimonial].quote}</p>
          <div className="quote-author">
            <span className="author-name">{testimonials[currentTestimonial].name}</span>
            <span className="author-title">{testimonials[currentTestimonial].title}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial; 
